class Card
{

    constructor(elem)
    {
        this.card = elem;
    }

    initialize()
    {
        let card = this.card;

        /*
        $(window).on('scroll', function() {
            let el = card;
            let product = $('[data-block-buy-button]');
            let top = product.offset().top + product.innerHeight() - 100;
            let scroll = $(document).scrollTop();
            let header = $('[data-header-sticky]');

            if (scroll > top) {
                el.addClass('show');
                header.addClass('relative');
            } else {
                el.removeClass('show')
                header.removeClass('relative');
            }
        });
        */
    }

    initializeCard()
    {


    }
}

export {Card};

$(function() {
    window.Card = Card;
});

$(window).on('load', () => {
    let cards = [];
    let cardCart = [];

    if ($('[data-card-micro]').length > 0) {
        $('[data-card-micro]').each(function(i) {
            cards[i] = new Card($(this));
            cards[i].initialize();
        });
    }

    if ($('[data-card]').length > 0) {
        $('[data-card]').each(function(i) {
            cardCart[i] = new Card($(this));
            cardCart[i].initializeCard();
        });
    }

    $('[data-card-favorite]').on('click', function(e) {
        const html = `Войдите или создайте учетную запись, чтобы добавить товар в избранное.`;
        $('#popup-auth .popup-inline__subtitle').html(html);
        $('#popup-auth').find('[data-popup-content]').removeClass('mt-0');

        e.preventDefault()
    });
});
